import Switch from './Switch.js';

export default Switch;